import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index3.js';
import { C as CURRENCY_MASK } from './form-input-masks.js';
import { l as label, t as text, N as inputGroup, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlHelpText } from './form-control-help-text2.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';

const MonetaryInput = /*@__PURE__*/ proxyCustomElement(class MonetaryInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, this.maskOptions);
            this.imask.on('accept', () => {
                const rawValue = this.imask.unmaskedValue;
                this.inputHandler(this.name, rawValue);
                this.formControlInput.emit({ name: this.name, value: rawValue });
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            const rawValue = this.imask.unmaskedValue;
            this.formControlInput.emit({ name: name, value: rawValue });
        };
        this.updateInput = (newValue) => {
            if (this.imask) {
                this.imask.value = String(newValue);
            }
        };
        this.isFocused = false;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.maskOptions = CURRENCY_MASK.DECIMAL;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.initializeIMask();
        this.updateInput(this.defaultValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    get part() {
        let part = inputGroup;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        return (h(Host, { key: '467e85f7211d67d6daabfcc8a3531b7ba2a15cb4' }, h("div", { key: '5566df3c8d8f9507acc27a7e47d9c79528928e8f', class: "form-group d-flex flex-column" }, h("label", { key: '5cee3c6dcc1d4e41184d4ad7185b8a8c50f9175a', part: label, class: "form-label", htmlFor: this.name }, this.label), h("div", { key: 'e111a7617526080c1d9e2051ff7476a768c8681e', class: "input-group" }, h("span", { key: '359a79709cad258033ee44ca6c4c320be1a85ce4', class: "input-group-text", part: text }, "$"), h("input", { key: '32dda535adca1021e46badb63d8ba064c936bd2f', ref: el => (this.textInput = el), id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-control monetary is-invalid' : 'form-control monetary', type: "text", disabled: this.disabled })), h(FormControlHelpText, { key: '560b1ef9506257d411d9d08e4a984195f1c3b948', helpText: this.helpText, name: this.name }), h(FormControlErrorText, { key: '7f4243a3d36cdd86129dca92e925e82917825d12', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-monetary", {
        "label": [1],
        "name": [1],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16],
        "maskOptions": [8, "mask-options"],
        "disabled": [4],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-monetary"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-monetary":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MonetaryInput);
            }
            break;
    } });
}
defineCustomElement();

export { MonetaryInput as M, defineCustomElement as d };
